/* eslint-disable max-lines */
import { Grid, Box, InputLabel, Radio, Typography, styled, Card } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { usePlaidLink } from 'react-plaid-link';
import { dgiMapping } from '../../../services/dgiMapping';
import { dgiContMapping } from '../../../services/dgiContMapping';
import ProgresaImage2 from '../../../images/EliteAcCImg3.png';
import AnotherBankAccountPlaid from '../../Plaid/AnotherBankAccountPlaid';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import { FundingScreenStyles as classes } from './FundingScreenStyles';
import { productMapping } from '../../../services/productMapping';
import NewAddressImage from '../../../images/featureFunding.svg';

import AnotherBankAccount from './AnotherBankAccount';
import OrientalAccount from './OrientalAccount';
import DebitCard from './DebitCard';
import StatementUpload from '../../Sidebar/StatementUpload';
import {
  getAccountValidation,
  getProductQuestionsForFunding,
  saveFundingDataWithPlaid,
  saveFundingInfo,
} from '../../../services/formService';
import { saveDgiFundingInfo } from '../../../services/dgiServices';
import {
  ELITE_ACCOUNT_EN,
  FUNDING_DISCLAIMER,
  FUNDING_HEAD,
  FUNDING_MSSG,
  FUNDING_TEXT,
  KNOCK_OFF_MSSG_BODY,
  MANDATORY_FIELD_ERR,
  NO,
  PRODUCT_IRAEDUCATION,
  PRODUCT_IRAFACIL,
  PRODUCT_PERSONAL,
  PRODUCT_PERSONALCD,
  PROD_NM_DGI_CONTRIBUTION,
  YES,
  FUND_UPLOAD_VOID_CHECK,
  DIRECT_DEPOSITE_RADIO_TEXT,
  LIBRE_AHORRA_BUNDLE,
  BUNDLE_FUNDING_DISCLAIMER,
  VOUCHED_ERROR,
  NOT_ELIGIBLE,
  NOT_ELIGIBLE_DESCRIPTION,
  FUNDING_DEPOSIT_QUESTION,
  CD_IRA,
} from '../../../constants';
import KnockOffModal from './KnockOffModal';
import { saveKnockOffData } from '../../DGI/CommonFunctions';
import Layout from '../../Layout';
import CustomSwitch from '../Switch/CustomSwitch';
import RetailImage3 from '../../../images/Retail_Image_3.png';
import RetailImage2 from '../../../images/Retail_Image_2.png';
import CommonModal from '../../Modal/CommonModal';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import {
  getOrientalAccountNumber,
  getPlaidLinkToken,
  sendPlaidPublicToken,
} from '../../../services/plaidService';

import {
  handleETBFlow,
  isPlaidProduct,
  isEtbFlow,
  isCDproduct,
  commonTernary,
  isBundle,
  isCDIraproduct,
} from '../../commonCode';
import { commonUtility } from '../UtilityFunctions';
import NewLayout from '../../Bundle/NewLayout';
import { LayoutStyles as bundleClasses } from '../../Bundle/LayoutStyles';
import CustomSwitchFunding from '../../Bundle/CustomSwitchFunding';
import BundleErrorModal from '../../Modal/BundleErrorModal';

const CustomRadio = styled(Radio)(({ theme }) => ({
  color: '#661C69',
  '&.Mui-checked': {
    color: '#661C69',
  },
}));

/** FundingScreen is the parent comp rendered on UI as a screen 6(screen 5 incase of IRA products) for normal account opening process and dgi product flow
Its child component are OrientalAccount, AnotherBankAccount,  DebitCard */
const FundingScreen = (props) => {
  const { t } = useTranslation();
  const [isValidating, setIsValidating] = React.useState(false);

  const [modalMessage, setModalMessage] = useState({ message: '', isKnockOff: false });
  const [isModal, setIsModal] = React.useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = React.useState(false);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { history } = props;
  const {
    productName,
    productType,
    location,
    language,
    setCurrentPage,
    fundData,
    fundDataErrors,
    setFundData,
    setOrientalAccountCardValue,
    setIsBalanceValidationFail,
    isFundingScreenDirty,
    setIsFundingScreenDirty,
    dgiFinanceInfo,
    setBankDetails,
    setFundDataErrors,
    accValidationErrCode,
    setAccValidationErrCode,
    setStatementUploadStatus,
    setStatementDocumentId,
    noRadio,
    setNoRadio,
    yesRadio,
    setYesRadio,
    setIsEdeliveryScreenDirty,
    isModalSaveLater,
    setIsModalSaveLater,
    customerType,
    setSingleAccDis,
    setPlaidSuccessDetails,
    flowTypeETB,
    customerAppId,
    accNoListForOrientalAccount,
    plaidDetails,
    statementDocumentId,
    statementUploadStatus,
    plaidAccNoLinked,
    setPlaidLinkTokenObj,
    accessToken,
    plaidLinkTokenObj,
    applicationId,
    setPlaidDetails,
    setSelectedOrientalAccountProgress,
    setPlaidAccNoLinked,
    setAccNoListForOrientalAccount,
    setPlaidRetry,
    callPlaidLink,
    setCallPlaidLink,
    selectedOrientalAccountProgress,
    plaidStatementMandatoryError,
    setPlaidStatementMandatoryError,
    savedDataFlow,
    statementUploadLoading,
    isFundingRequired,
    orientalAccountCardValue,
    cdFlowOffers,
    theme,
    productDataIRA,
  } = leadGenerationContext;
  const [expcodes, setExpcodes] = useState([]);
  useEffect(() => {
    const plaidInitialCall = async () => {
      setIsValidating(true);
      const linkTokenResponse = await getPlaidLinkToken(accessToken, language);
      if (linkTokenResponse && linkTokenResponse.status === 200) {
        setIsValidating(false);
        setPlaidLinkTokenObj(linkTokenResponse.data);
      } else {
        // ;;;
      }
    };

    const conditionToPlaidLink =
      ((fundData.anotherBankAccount && customerType === 'ETB') ||
        customerType === 'NTB' ||
        customerType === 'ETB') &&
      isPlaidProduct(leadGenerationContext.productName) &&
      Object?.keys(plaidLinkTokenObj).length < 1;

    if (conditionToPlaidLink) {
      if (callPlaidLink === true) {
        plaidInitialCall();
      }
    }
  }, [fundData.anotherBankAccount, customerType, productName, callPlaidLink, plaidLinkTokenObj]);

  useEffect(() => {
    setPlaidLinkTokenObj({});
  }, [language]);

  let appId;
  if (flowTypeETB === 'EtbFlow') {
    appId = leadGenerationContext.customerAppId;
  } else {
    appId = leadGenerationContext.applicationId;
  }

  const errordisplay = (publicTokenResponse) => {
    let errormsg = '';
    if (isPlaidProduct(leadGenerationContext.productName)) {
      if (
        publicTokenResponse.data.verifiedAccounts[0]?.AccountNumber.length < 9 &&
        publicTokenResponse.data.verifiedAccounts[0]?.AccountNumber.length > 17
      ) {
        errormsg = 'Account number exceeds the maximum allowed limit';
      } else {
        errormsg = '';
      }
    } else if (productMapping(productName) === 'Libre') {
      if (
        publicTokenResponse.data.verifiedAccounts[0]?.AccountNumber.length < 9 ||
        publicTokenResponse.data.verifiedAccounts[0]?.AccountNumber.length > 16
      ) {
        errormsg = 'Account number exceeds the maximum allowed limit';
      } else {
        errormsg = '';
      }
    } else {
      errormsg = '';
    }
    return errormsg;
  };

  const { open, ready } = usePlaidLink({
    token: plaidLinkTokenObj?.linkToken,
    // eslint-disable-next-line camelcase
    onSuccess: (publicToken, metadata) => {
      (async () => {
        setIsValidating(true);
        const publicTokenResponse = await sendPlaidPublicToken(
          publicToken,
          plaidLinkTokenObj.uuid,
          appId,
          accessToken
        );
        if (publicTokenResponse && publicTokenResponse.status === 200) {
          setIsValidating(false);
          setPlaidDetails(publicTokenResponse.data);
          if (publicTokenResponse.data?.remarks === 'pending_manual_verification') {
            setPlaidStatementMandatoryError(false);
          }
          if (publicTokenResponse.data.verifiedAccounts) {
            if (publicTokenResponse.data?.status === 'Success') {
              setPlaidStatementMandatoryError(false);

              if (publicTokenResponse.data.verifiedAccounts.length > 1) {
                setFundData((prevState) => ({
                  ...prevState,
                  Id: '',
                  accountNumber: '',
                  maskedAccId: '',
                  transitNumber: '',
                  typeOfAccount: '',
                  balance: '',
                }));
                setFundDataErrors((prevState) => ({
                  ...prevState,

                  bank: '',
                  statementDocumentId: '',
                  transitNumber: '',
                  typeOfAccount: '',
                }));
                const updateAccountDetailsPlaid = publicTokenResponse.data.verifiedAccounts.map(
                  (option) => {
                    let isDepositeGreaterThanBalancePlaid;
                    if (fundData.minDepositAmount) {
                      isDepositeGreaterThanBalancePlaid =
                        option.Balance < fundData.minDepositAmount;
                    }
                    return { ...option, isDepositeGreaterThanBalancePlaid };
                  }
                );

                setPlaidAccNoLinked(updateAccountDetailsPlaid);
              } else if (publicTokenResponse.data.verifiedAccounts?.length === 1) {
                if (
                  fundData.minDepositAmount &&
                  publicTokenResponse.data?.status === 'Success' &&
                  fundData.minDepositAmount.toString().replace(',', '') >
                    publicTokenResponse.data.verifiedAccounts[0]?.Balance
                ) {
                  const updateAccountDetailsPlaid = publicTokenResponse.data.verifiedAccounts?.map(
                    (option) => {
                      console.log({
                        ...option,
                        isDepositeGreaterThanBalancePlaid:
                          option.Balance < fundData.minDepositAmount,
                      });
                      return {
                        ...option,
                        isDepositeGreaterThanBalancePlaid:
                          option.Balance < fundData.minDepositAmount,
                      };
                    }
                  );
                  setPlaidAccNoLinked(updateAccountDetailsPlaid);
                  setSingleAccDis(true);
                  setPlaidSuccessDetails((prevState) => ({
                    ...prevState,
                    accId: publicTokenResponse.data.verifiedAccounts[0]?.Id,
                  }));
                  setFundData((prevState) => ({
                    ...prevState,
                    Id: publicTokenResponse.data.verifiedAccounts[0]?.Id,
                    accountNumber: publicTokenResponse.data.verifiedAccounts[0]?.AccountNumber,
                    maskedAccId: publicTokenResponse.data.verifiedAccounts[0]?.Id,
                    transitNumber: publicTokenResponse.data.verifiedAccounts[0]?.RoutingNumber,
                    typeOfAccount: publicTokenResponse.data.verifiedAccounts[0]?.AccountType,
                    balance: publicTokenResponse.data.verifiedAccounts[0]?.Balance,
                  }));
                  setFundDataErrors((prevState) => ({
                    ...prevState,
                    accountNumber: errordisplay(publicTokenResponse),
                    bank: '',
                    statementDocumentId: '',
                    transitNumber: '',
                    typeOfAccount: '',
                  }));

                  // setFundDataErrors({
                  //   ...fundDataErrors,
                  //   depositAmount:
                  //     '* Please review the deposit amount entered as it is more than the available balance on this account',
                  // });
                } else {
                  setPlaidAccNoLinked(publicTokenResponse.data.verifiedAccounts);
                  setPlaidSuccessDetails((prevState) => ({
                    ...prevState,
                    accId: publicTokenResponse.data.verifiedAccounts[0]?.Id,
                  }));
                  setFundData((prevState) => ({
                    ...prevState,
                    Id: publicTokenResponse.data.verifiedAccounts[0]?.Id,
                    accountNumber: publicTokenResponse.data.verifiedAccounts[0]?.AccountNumber,
                    maskedAccId: publicTokenResponse.data.verifiedAccounts[0]?.Id,
                    transitNumber: publicTokenResponse.data.verifiedAccounts[0]?.RoutingNumber,
                    typeOfAccount: publicTokenResponse.data.verifiedAccounts[0]?.AccountType,
                    balance: publicTokenResponse.data.verifiedAccounts[0]?.Balance,
                  }));
                  setFundDataErrors((prevState) => ({
                    ...prevState,
                    accountNumber: errordisplay(publicTokenResponse),
                  }));
                  setSingleAccDis(false);
                }
              }
            } else {
              setPlaidAccNoLinked(publicTokenResponse.data.verifiedAccounts);
            }
          }
        } else {
          setIsValidating(false);
          setPlaidRetry((retryCount) => retryCount + 1);
          setPlaidDetails({ status: 'Failed' });
        }
      })();
    },
    onEvent: (eventName, metadata) => {
      if (eventName === 'ERROR') {
        setPlaidDetails({ status: 'Failed' });
        setPlaidRetry((retryCount) => retryCount + 1);
      }
    },
    onExit: (error, metadata) => {
      // if (error?.error_code) {
      //   setPlaidDetails({ status: 'Failed' });
      //   setPlaidRetry((retryCount) => retryCount + 1);
      // }
    },
  });

  const fundingAmountCall = (data) => {
    if (data && data.fundingAmount) {
      const minAmount = data.fundingAmount[0]?.minimumAmount
        ? data.fundingAmount[0].minimumAmount
        : '';

      if (!fundData?.minDepositAmount) {
        setFundData((prevState) => ({
          ...prevState,
          minDepositAmount: minAmount,
        }));
      }
    }
  };

  const handleOnLoadFundingPage = async () => {
    setCurrentPage('funding-info');

    setIsValidating(true);
    const formData = {
      productType,
      productName,
      language,
      location,
      customerType,
      flowTypeETB,
      customerAppId,
    };

    if (leadGenerationContext.accessToken) {
      // const prodData = FundingOnLoad;
      const prodData = await getProductQuestionsForFunding(
        formData,
        isBundle(productName) ? 'FundingBundleDeposit' : 'FundingDeposit',
        leadGenerationContext.accessToken
      );

      if (prodData && prodData.data) {
        const data = isBundle(productName)
          ? prodData?.data?.FundingBundleDeposit[0]
          : prodData?.data?.FundingDeposit[0];

        fundingAmountCall(data);
        if (data?.bankInfo) {
          setBankDetails(data.bankInfo);
        }
        if (!isPlaidProduct(leadGenerationContext.productName)) {
          setIsValidating(false);
        }
        if (
          (isPlaidProduct(leadGenerationContext.productName) &&
            customerType === 'ETB' &&
            fundData.orientalAccount) ||
          (savedDataFlow && customerType === 'ETB')
        ) {
          if (appId && leadGenerationContext.accessToken) {
            setIsValidating(true);
            // const accountsResponse = {
            //   data: [
            //     {
            //       Id: 'fb0cbfc39e8f832e13742487b0a197fb0eaddac99b625d13f28768f8ee2f32a2',
            //       AccountNumber: '******8826',
            //       AccountType: 'CHECKING ACCOUNT',
            //       Balance: '8768',
            //     },
            //     {
            //       Id: '19b84f97d07df38a44643d037ad39b2176b9593c56acf06a7c35b739fddc7f64',
            //       AccountNumber: '******1543',
            //       AccountType: 'CHECKING ACCOUNT',
            //       Balance: '9898',
            //     },
            //     {
            //       Id: '977c3a790d23e5d3de765ad728d6364b2e098eebc63d924be022bef3bce9a815',
            //       AccountNumber: '******1543',
            //       AccountType: 'SAVING ACCOUNT',
            //       Balance: '8778',
            //     },
            //     {
            //       Id: '8295136b42c3f02d4627e8444c75027bc9b2f0b3178233c163e1d0d453cfab17',
            //       AccountNumber: '******2052',
            //       AccountType: 'SAVING ACCOUNT',
            //       Balance: '76576',
            //     },
            //   ],
            //   status: 200,
            // };

            const accountsResponse = await getOrientalAccountNumber(
              appId,
              leadGenerationContext.accessToken
            );
            if (accountsResponse && accountsResponse.status === 200) {
              setIsValidating(false);
              setCallPlaidLink(true);
              // set response to setAccNoListForOrientalAccount,

              if (
                accountsResponse.data?.length > 0 &&
                customerType === 'ETB' &&
                isPlaidProduct(leadGenerationContext.productName)
              ) {
                const updateAccountDetails = accountsResponse.data.map((option) => {
                  let isDepositeGreaterThanBalance = false;
                  const val = option.Balance.replace(/,/g, '');

                  const balance = parseFloat(val);

                  if (
                    (fundData.minDepositAmount || data.fundingAmount[0]?.minimumAmount) &&
                    option.Balance != ''
                  ) {
                    isDepositeGreaterThanBalance = balance < data.fundingAmount[0]?.minimumAmount;
                  }
                  return { ...option, isDepositeGreaterThanBalance };
                });
                setAccNoListForOrientalAccount(updateAccountDetails);
              } else if (
                accountsResponse.data?.length < 1 &&
                customerType === 'ETB' &&
                isPlaidProduct(leadGenerationContext.productName)
              ) {
                setAccNoListForOrientalAccount([]);
                setFundData((prevState) => ({
                  ...prevState,
                  orientalAccount: false,
                  anotherBankAccount: true,
                }));
              }
            } else {
              setCallPlaidLink(true);
              setIsValidating(false);
            }
          }
        } else {
          setCallPlaidLink(true);
          setIsValidating(false);
        }
      }
    }
  };

  // set current page to 'funding-info'
  useEffect(() => {
    handleOnLoadFundingPage();
  }, []);

  useEffect(() => {
    if (
      cdFlowOffers?.depositAmount &&
      customerType === 'ETB' &&
      leadGenerationContext.fundData.orientalAccount &&
      leadGenerationContext.accNoListForOrientalAccount?.length > 0
    ) {
      const accountVal = accNoListForOrientalAccount?.find(
        (x) => x.Id === orientalAccountCardValue?.Id
      );

      if (isCDproduct(productName)) {
        setFundData({
          ...fundData,
          depositAmount: cdFlowOffers?.depositAmount,
          minDepositAmount: '1000',
          accountNumber: commonUtility(accountVal?.AccountNumber),
        });
      } else if (isCDIraproduct(productName)) {
        setFundData({
          ...fundData,
          depositAmount: productDataIRA?.depositAmount
            ? productDataIRA?.depositAmount
            : cdFlowOffers?.depositAmount,
          minDepositAmount: '250',
          accountNumber: commonUtility(accountVal?.AccountNumber),
        });
      }
    }
  }, [accNoListForOrientalAccount, cdFlowOffers?.depositAmount]);
  const back = (e) => {
    e.preventDefault();
    const prodName = productMapping(productName);

    // Navigate back to screen one (contact) with handle back action on funding screen of DGI contribution product
    if (dgiContMapping(productName) || dgiMapping(productName) === PROD_NM_DGI_CONTRIBUTION) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/contact-info`
      );
    } else if (isEtbFlow(leadGenerationContext)) {
      if (isCDproduct(productName) || isCDIraproduct(productName)) {
        handleETBFlow(leadGenerationContext, history, 'product-info');
      } else {
        handleETBFlow(leadGenerationContext, history, 'feature-info');
      }
    }
    // Navigate back to screen five (Finance page) with handle back action on funding screen of DGI Balanced Fund IRA product flow
    else if (dgiMapping(productName)) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/finance-info`
      );
    } else if (
      // prodName === PRODUCT_PERSONAL ||
      prodName === PRODUCT_IRAFACIL ||
      prodName === PRODUCT_IRAEDUCATION ||
      prodName === PRODUCT_PERSONALCD
    ) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/compliance-info`
      );
    } else if (
      productMapping(productName) === 'Ahorra' ||
      (productMapping(productName) === 'Libre' && isFundingRequired === DIRECT_DEPOSITE_RADIO_TEXT)
    ) {
      history.push({
        pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/feature-info`,
      });
    } else if (
      productMapping(productName) === ELITE_ACCOUNT_EN ||
      productMapping(productName) === 'Ahorra' ||
      productMapping(productName) === LIBRE_AHORRA_BUNDLE
    ) {
      history?.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/feature-info`
      );
    } else {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/product-info`
      );
    }
  };
  /**
   * call save api for dgi product and normal account opening products */
  const saveData = async () => {
    const data = { ...fundData };
    const dgidata = { ...dgiFinanceInfo };
    data.applicationId = leadGenerationContext.applicationId;
    data.language = leadGenerationContext.language;
    data.location = leadGenerationContext.location;
    data.utmCampaign = leadGenerationContext.utmCampaign;
    data.utmMedium = leadGenerationContext.utmMedium;
    data.utmContent = leadGenerationContext.utmContent;
    data.utmTerm = leadGenerationContext.utmTerm;
    data.utmSource = leadGenerationContext.utmSource;
    data.branchCode = leadGenerationContext.branchCode;
    data.productType = leadGenerationContext.productType;
    data.productName = leadGenerationContext.productName;
    data.statementDocumentId = leadGenerationContext.statementDocumentId;
    data.isAccountBelongsToYou = yesRadio ? YES : NO;
    data.customerType = customerType;
    data.flowTypeETB = flowTypeETB;
    data.customerAppId = customerAppId;
    data.sourceofFunds = leadGenerationContext.fundData?.sourceofFunds?.value;
    data.typeOfAccount =
      leadGenerationContext.fundData.typeOfAccount?.toUpperCase().includes('CHECKING') ||
      leadGenerationContext.orientalAccountCardValue.AccountType?.toUpperCase().includes('CHECKING')
        ? 'Checking'
        : 'Savings';

    let response;
    if (dgiMapping(productName)) {
      response = await saveDgiFundingInfo(data, dgidata, leadGenerationContext.accessToken);
    } else if (isPlaidProduct(leadGenerationContext.productName)) {
      response = await saveFundingDataWithPlaid(data, leadGenerationContext);
    } else {
      response = await saveFundingInfo(data, leadGenerationContext.accessToken);
    }
    return response;
  };
  let valid = true;
  const otherBankMandatory = () => {
    if (fundData.bank === 'Other') {
      if (!fundData.otherBank) {
        valid = false;
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          otherBank: MANDATORY_FIELD_ERR,
        }));
      }
    }
  };
  const anotherBankAccountErrorsPlaid = () => {
    if (!plaidDetails?.status || plaidDetails?.status === 'Failed') {
      if (!leadGenerationContext.statementDocumentId) {
        valid = false;
        setFundData({ ...fundData, statementUpload: true });
      } else {
        setFundData({ ...fundData, statementUpload: false });
      }
    }
    if (!fundData.depositAmount) {
      valid = false;

      setFundDataErrors((prevState) => ({
        ...prevState,

        depositAmount: MANDATORY_FIELD_ERR,
      }));
    }
    if (!fundData.minDepositAmount) {
      valid = false;

      setFundDataErrors((prevState) => ({
        ...prevState,

        minDepositAmount: MANDATORY_FIELD_ERR,
      }));
    }
    if (plaidDetails?.status === 'Success' && !plaidDetails?.remarks) {
      if (!fundData.accountNumber) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,

          accountNumber: MANDATORY_FIELD_ERR,
        }));
      }

      if (!fundData.minDepositAmount) {
        valid = false;

        setFundDataErrors((prevState) => ({
          ...prevState,

          minDepositAmount: MANDATORY_FIELD_ERR,
        }));
      }
      if (!fundData.depositAmount) {
        valid = false;

        setFundDataErrors((prevState) => ({
          ...prevState,

          depositAmount: MANDATORY_FIELD_ERR,
        }));
      }
    }
    if (
      statementDocumentId !== null &&
      statementUploadStatus !== null &&
      (plaidDetails?.status === '' || plaidDetails?.status === 'Failed')
    ) {
      if (!fundData.depositAmount) {
        valid = false;

        setFundDataErrors((prevState) => ({
          ...prevState,

          depositAmount: MANDATORY_FIELD_ERR,
        }));
      }
      if (!fundData.accountNumber) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,

          accountNumber: MANDATORY_FIELD_ERR,
        }));
      }
      if (!fundData.typeOfAccount) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,

          typeOfAccount: MANDATORY_FIELD_ERR,
        }));
      }
      if (!fundData.bank) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,

          bank: MANDATORY_FIELD_ERR,
        }));
      }
      if (fundData.bank === 'Other') {
        if (!fundData.otherBank) {
          valid = false;
          leadGenerationContext.setFundDataErrors((prevState) => ({
            ...prevState,
            otherBank: MANDATORY_FIELD_ERR,
          }));
        }
      }
      if (fundData?.transitNumber === 'Other') {
        if (!fundData?.customTransitNumber) {
          valid = false;
          leadGenerationContext.setFundDataErrors((prevState) => ({
            ...prevState,
            customTransitNumber: MANDATORY_FIELD_ERR,
          }));
        }
      } else if (!fundData?.transitNumber) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,

          transitNumber: MANDATORY_FIELD_ERR,
        }));
      }
    }
    if (Object.entries(fundData.sourceofFunds || {}).length === 0 && isPlaidProduct(productName)) {
      valid = false;
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        sourceofFunds: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const anotherBankAccountErrors = () => {
    if (!leadGenerationContext.statementDocumentId) {
      valid = false;
      setFundData({ ...fundData, statementUpload: true });
    } else {
      setFundData({ ...fundData, statementUpload: false });
    }
    if (!fundData.accountNumber) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,

        accountNumber: MANDATORY_FIELD_ERR,
      }));
    }
    if (!fundData.typeOfAccount) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,

        typeOfAccount: MANDATORY_FIELD_ERR,
      }));
    }
    if (!fundData.bank) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,

        bank: MANDATORY_FIELD_ERR,
      }));
    }
    otherBankMandatory();

    if (fundData.transitNumber === 'Other') {
      if (!fundData.customTransitNumber) {
        valid = false;
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: MANDATORY_FIELD_ERR,
        }));
      }
    } else if (!fundData.transitNumber) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,

        transitNumber: MANDATORY_FIELD_ERR,
      }));
    }

    if (dgiContMapping(productName)) {
      if (!fundData?.dgiAccountNumber) {
        valid = false;

        setFundDataErrors((prevState) => ({
          ...prevState,
          dgiAccountNumber: MANDATORY_FIELD_ERR,
        }));
      }
    }
    if (!fundData.depositAmount) {
      valid = false;

      setFundDataErrors((prevState) => ({
        ...prevState,

        depositAmount: MANDATORY_FIELD_ERR,
      }));
    }

    if (dgiMapping(productName)) {
      if (!fundData.taxYear) {
        valid = false;

        setFundDataErrors((prevState) => ({
          ...prevState,

          taxYear: MANDATORY_FIELD_ERR,
        }));
      }
    }
    if (!fundData.minDepositAmount) {
      valid = false;

      setFundDataErrors((prevState) => ({
        ...prevState,

        minDepositAmount: MANDATORY_FIELD_ERR,
      }));
    }
  };
  // check orientalAccount mandatory fields
  const orientalAccountErrors = () => {
    if (Object.entries(orientalAccountCardValue).length > 0) {
      setIsSubmitClicked(true);
    }
    if (isCDIraproduct(productName) && flowTypeETB === 'EtbFlow') {
      const minDeposit = parseFloat(fundData?.minDepositAmount ?? 0);
      const isSelectable = (list = []) =>
        list.some(({ Balance, isDepositeError, isValid }) => {
          const balance = parseFloat((Balance ?? '0').toString().replace(/,/g, '')) || 0;
          const disabled = isDepositeError || isValid || balance === 0 || balance < minDeposit;
          return !disabled;
        });
      const anySelectableInAccNoList = isSelectable(accNoListForOrientalAccount);
      if (!anySelectableInAccNoList) {
        valid = false;
        leadGenerationContext.setFundDataErrors((prev) => ({
          ...prev,
          accountNumber: MANDATORY_FIELD_ERR,
        }));
        return;
      }
    }
    if (!fundData.accountNumber) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        accountNumber: MANDATORY_FIELD_ERR,
      }));
    }
    if (!fundData.typeOfAccount && !(isCDproduct(productName) || isCDIraproduct(productName))) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        typeOfAccount: MANDATORY_FIELD_ERR,
      }));
    }
    if (!fundData.minDepositAmount) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        minDepositAmount: MANDATORY_FIELD_ERR,
      }));
    }
    if (!fundData.depositAmount) {
      valid = false;

      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        depositAmount: MANDATORY_FIELD_ERR,
      }));
    }
    if (
      Object.entries(fundData.sourceofFunds || {}).length === 0 &&
      (isCDproduct(productName) || isCDIraproduct(productName))
    ) {
      valid = false;
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        sourceofFunds: MANDATORY_FIELD_ERR,
      }));
    }
    if (dgiContMapping(productName)) {
      if (!fundData?.dgiAccountNumber) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          dgiAccountNumber: MANDATORY_FIELD_ERR,
        }));
      }
    }
    if (dgiMapping(productName)) {
      if (!fundData.taxYear) {
        valid = false;

        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          taxYear: MANDATORY_FIELD_ERR,
        }));
      }
    }
  };

  const isFormValid = () => {
    if (isPlaidProduct(leadGenerationContext.productName)) {
      const conditionToCallAnotherAcc =
        (customerType === 'ETB' &&
          accNoListForOrientalAccount?.length > 0 &&
          fundData.anotherBankAccount) ||
        customerType === 'NTB' ||
        (customerType === 'NTB' && fundData.anotherBankAccount) ||
        (customerType === 'ETB' && accNoListForOrientalAccount?.length <= 0);

      if (conditionToCallAnotherAcc) {
        anotherBankAccountErrorsPlaid();
      }
      if (fundData.orientalAccount && customerType !== 'NTB') {
        orientalAccountErrors();
      }
    } else if (fundData.anotherBankAccount) {
      anotherBankAccountErrors();
    } else if (fundData.orientalAccount) {
      orientalAccountErrors();
    }

    for (const key in fundDataErrors) {
      if (fundDataErrors[key]) {
        valid = false;
        break;
      }
    }

    return valid;
  };
  const disableAccountBalance = () => {
    const arr = [];
    plaidAccNoLinked.forEach((option) => {
      if (!option?.isValids) {
        const isValids = option.AccountNumber === fundData?.accountNumber;
        arr.push({ ...option, isValids });
      } else {
        arr.push({ ...option, isValids: true });
      }
    });
    return arr;
  };
  const disableAccountBalanceOri = () => {
    const arr = [];
    accNoListForOrientalAccount.forEach((option) => {
      if (!option?.isDepositeError) {
        const accountId =
          isCDproduct(productName) || isCDIraproduct(productName)
            ? orientalAccountCardValue?.Id
            : fundData?.Id;
        const isDepositeError = option.Id === accountId;
        arr.push({ ...option, isDepositeError });
      } else {
        arr.push({ ...option, isDepositeError: true });
      }
    });
    return arr;
  };

  /**
   * With successful save status 201, If the product is DGI contribution and normal account process, it will be routed to consent screen(Screen 3)
   * With successful save status 201, If the product is DGI Balanced Fund IRA, it will be routed to e-delivery screen(Screen 6)  */
  const validatedResult = async (result) => {
    if (result && result.status === 201) {
      setIsValidating(false);
      setIsFundingScreenDirty(false);
      if (dgiMapping(productName) === PROD_NM_DGI_CONTRIBUTION) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/consent-info`
        );
      } else if (dgiMapping(productName)) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/edelivery-info`
        );
      } else if (isCDproduct(productName) || isCDIraproduct(productName)) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}${commonTernary(
            isEtbFlow(leadGenerationContext),
            '/express',
            ''
          )}/retail-form/${productNameURLMapping(leadGenerationContext.productName)}/cd-review`
        );
      } else {
        setIsBalanceValidationFail(false);
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}${commonTernary(
            isEtbFlow(leadGenerationContext),
            '/express',
            ''
          )}/retail-form/${productNameURLMapping(leadGenerationContext.productName)}/consent-info`
        );
      }
    } else {
      if (result.data === 'Selected Account is not having sufficient balance') {
        if (fundData.orientalAccount && isPlaidProduct(leadGenerationContext.productName)) {
          // isDepositeGreaterThanBalance
          // setFlag true for oriental to clear error
          setIsBalanceValidationFail(true);
          const resultAcc = disableAccountBalanceOri();
          setAccNoListForOrientalAccount(resultAcc);
          setFundDataErrors({
            ...fundDataErrors,
            depositAmount:
              '* Please review the deposit amount entered as it is more than the available balance on this account',
          });
        } else if (
          (customerType === 'ETB' && fundData?.accountTransferOrCheck) ||
          customerType === 'NTB' ||
          (customerType === 'ETB' && accNoListForOrientalAccount?.length < 0) ||
          plaidDetails?.status === 'Success' ||
          (statementDocumentId === null && statementUploadStatus === null)
        ) {
          const resultAcc = disableAccountBalance();
          setPlaidAccNoLinked(resultAcc);
          if (isCDIraproduct(productName) && flowTypeETB === 'EtbFlow') {
            setFundDataErrors({
              ...fundDataErrors,
              accountNumber:
                '* Please review the deposit amount entered as it is more than the available balance on this account. Return to the previous step and enter a lower amount to continue.',
            });
          } else {
            setFundDataErrors({
              ...fundDataErrors,
              accountNumber:
                '* Please review the deposit amount entered as it is more than the available balance on this account',
            });
          }
        }
      }
      setIsValidating(false);
    }
  };

  const setFocus = (fields) => {
    for (const field of fields) {
      if (!fundData[field]) {
        const element = document.getElementById(field);
        if (element) {
          // element.focus();
          break;
        }
      }
    }
  };

  // Focus check on funding screen mandatory error object fields(OrientalAccount & AnotherBankAccount)
  let isElementFound = false;
  const setFocusError = (fields) => {
    for (const field of fields) {
      if (fundDataErrors[field]) {
        const element = document.getElementById(field);
        if (element) {
          isElementFound = true;
          // element.focus();
          break;
        }
      }
    }
  };

  // Focus check for DGI product OrientalAccount mandatory fields
  const dgiOrientalValidation = () => {
    if (fundData?.orientalAccount) {
      const fields = ['depositAmount', 'typeOfAccount', 'accountNumber', 'taxYear'];
      setFocusError(fields);
      if (!isElementFound) {
        setFocus(fields);
      }
    }
  };
  // Focus check for DGI Contribution OrientalAccount mandatory fields
  const dgiContOrientalValidation = () => {
    if (fundData?.orientalAccount) {
      const fields = [
        'depositAmount',
        'typeOfAccount',
        'accountNumber',
        'taxYear',
        'dgiAccountNumber',
      ];
      setFocusError(fields);
      if (!isElementFound) {
        setFocus(fields);
      }
    }
  };
  // Focus check for OrientalAccount mandatory fields for normal account process
  const orientalValidation = () => {
    if (fundData?.orientalAccount) {
      const fields = ['depositAmount', 'typeOfAccount', 'accountNumber', 'sourceOfFunds'];
      setFocusError(fields);
      if (!isElementFound) {
        setFocus(fields);
      }
    }
  };
  // Focus check for AnotherBankAccount doumnet upload icon for normal account process
  const anotherBankAccountUploadDocFocus = () => {
    if (fundData?.anotherBankAccount) {
      const isUploadElementFound = false;
      if (!isUploadElementFound) {
        if (!fundData.statementDocumentId) {
          const element = document.getElementById('uploadDocId');
          if (element) {
            // element.focus();
          }
        }
      }
    }
  };
  // Focus check for AnotherBankAccount mandatory fields for normal account process
  const anotherBankValidation = () => {
    let fields = [];
    if (fundData?.debitCard) {
      fields.push('depositAmount', 'cardNumber', 'expiryMonth', 'expiryYear');
    } else if (fundData?.accountTransferOrCheck && fundData?.orientalAccount) {
      fields.push('depositAmount', 'typeOfAccount', 'accountNumber');
    } else if (
      fundData?.accountTransferOrCheck &&
      fundData?.anotherBankAccount &&
      fundData?.bank !== 'Other'
    ) {
      fields.push('depositAmount', 'typeOfAccount', 'accountNumber', 'bank', 'transitNumber');
    } else if (
      fundData?.accountTransferOrCheck &&
      fundData?.anotherBankAccount &&
      fundData?.bank === 'Other'
    ) {
      fields.push(
        'depositAmount',
        'typeOfAccount',
        'accountNumber',
        'bank',
        'otherBank',
        'transitNumber'
      );
    } else {
      fields = [];
    }
    setFocusError(fields);
    if (!isElementFound) {
      setFocus(fields);
    }
  };
  const focusAnotherBankAccountPlaid = () => {
    const element = [];
    if (customerType === 'ETB') {
      if (accNoListForOrientalAccount.length > 0) {
        if (fundData?.accountTransferOrCheck && fundData?.anotherBankAccount) {
          // doc upload done and no plaid
          if (
            statementDocumentId !== null &&
            statementUploadStatus !== null &&
            plaidDetails === ''
          ) {
            if (fundData?.bank !== 'Other') {
              element.push(
                'depositAmount',
                'typeOfAccount',
                'accountNumber',
                'bank',
                'transitNumber'
              );
            } else if (fundData?.bank === 'Other') {
              element.push(
                'depositAmount',
                'typeOfAccount',
                'accountNumber',
                'bank',
                'otherBank',
                'transitNumber'
              );
            }
          } else if (
            statementDocumentId === null &&
            statementUploadStatus === null &&
            plaidDetails !== ''
          ) {
            element.push('depositAmount');
          }
        }
      } else if (accNoListForOrientalAccount.length < 0) {
        if (statementDocumentId !== null && statementUploadStatus !== null && plaidDetails === '') {
          if (fundData?.bank !== 'Other') {
            element.push(
              'depositAmount',
              'typeOfAccount',
              'accountNumber',
              'bank',
              'transitNumber'
            );
          } else if (fundData?.bank === 'Other') {
            element.push(
              'depositAmount',
              'typeOfAccount',
              'accountNumber',
              'bank',
              'otherBank',
              'transitNumber'
            );
          }
        } else if (
          statementDocumentId === null &&
          statementUploadStatus === null &&
          plaidDetails !== ''
        ) {
          element.push('depositAmount');
        }
      }
    } else if (customerType === 'NTB') {
      if (statementDocumentId !== null && statementUploadStatus !== null && plaidDetails === '') {
        if (fundData?.bank !== 'Other') {
          element.push('depositAmount', 'typeOfAccount', 'accountNumber', 'bank', 'transitNumber');
        } else if (fundData?.bank === 'Other') {
          element.push(
            'depositAmount',
            'typeOfAccount',
            'accountNumber',
            'bank',
            'otherBank',
            'transitNumber'
          );
        }
      } else if (
        statementDocumentId === null &&
        statementUploadStatus === null &&
        plaidDetails !== ''
      ) {
        element.push('depositAmount');
      }
    }
    return element;
  };
  const anotherBankValidationPlaid = () => {
    // const conditionToDepositeInp =
    //   customerType === 'NTB' ||
    //   (customerType === 'ETB' &&
    //     accNoListForOrientalAccount?.length < 0 &&
    //     fundData?.anotherBankAccount &&
    //     !fundData.orientalAccount) ||
    //   (customerType === 'ETB' &&
    //     accNoListForOrientalAccount?.length > 0 &&
    //     fundData?.anotherBankAccount &&
    //     !fundData.orientalAccount &&
    //     statementDocumentId === null &&
    //     statementUploadStatus === null) ||
    //   (plaidDetails.status === '' &&
    //     statementDocumentId === null &&
    //     statementUploadStatus === null &&
    //     fundData?.anotherBankAccount &&
    //     !fundData.orientalAccount) ||
    //   (fundData?.anotherBankAccount &&
    //     customerType === 'ETB' &&
    //     statementDocumentId === null &&
    //     statementUploadStatus === null);

    // const conditionForOtherInp =
    //   statementDocumentId !== null && statementUploadStatus !== null && fundData?.bank === 'Other';

    // const conditionForOnlyBankInp =
    //   statementDocumentId !== null && statementUploadStatus !== null && fundData?.bank !== 'Other';

    // if (conditionToDepositeInp) {
    //   fields.push('depositAmount');
    // } else if (conditionForOnlyBankInp) {
    //   fields.push('depositAmount', 'typeOfAccount', 'accountNumber', 'bank', 'transitNumber');
    // } else if (conditionForOtherInp) {
    //   fields.push(
    //     'depositAmount',
    //     'typeOfAccount',
    //     'accountNumber',
    //     'bank',
    //     'otherBank',
    //     'transitNumber'
    //   );
    // } else {
    //   fields = [];
    // }
    const fields = [];
    if (customerType === 'ETB') {
      if (accNoListForOrientalAccount.length > 0) {
        if (fundData?.accountTransferOrCheck && fundData?.anotherBankAccount) {
          // doc upload done and no plaid
          if (
            statementDocumentId !== null &&
            statementUploadStatus !== null &&
            plaidDetails.status === ''
          ) {
            if (fundData?.bank !== 'Other') {
              fields.push(
                'depositAmount',
                'typeOfAccount',
                'accountNumber',
                'bank',
                'transitNumber'
              );
            } else if (fundData?.bank === 'Other') {
              fields.push(
                'depositAmount',
                'typeOfAccount',
                'accountNumber',
                'bank',
                'otherBank',
                'transitNumber'
              );
            }
          } else if (
            statementDocumentId === null &&
            statementUploadStatus === null &&
            plaidDetails.status !== ''
          ) {
            if (plaidDetails.status === 'Success') {
              fields.push('accountNumber,depositAmount');
            } else {
              fields.push('depositAmount');
            }
          }
        }
      } else if (accNoListForOrientalAccount.length <= 0) {
        if (
          statementDocumentId !== null &&
          statementUploadStatus !== null &&
          plaidDetails.status === ''
        ) {
          if (fundData?.bank !== 'Other' || fundData?.bank === '') {
            fields.push('depositAmount', 'typeOfAccount', 'accountNumber', 'bank', 'transitNumber');
          } else if (fundData?.bank === 'Other') {
            fields.push(
              'depositAmount',
              'typeOfAccount',
              'accountNumber',
              'bank',
              'otherBank',
              'transitNumber'
            );
          }
        } else if (
          statementDocumentId === null &&
          statementUploadStatus === null &&
          plaidDetails.status !== ''
        ) {
          if (plaidDetails.status === 'Success') {
            fields.push('accountNumber,depositAmount');
          } else {
            fields.push('depositAmount');
          }
        }
      }
    } else if (customerType === 'NTB') {
      if (
        statementDocumentId !== null &&
        statementUploadStatus !== null &&
        plaidDetails.status === ''
      ) {
        if (fundData?.bank !== 'Other') {
          fields.push('depositAmount', 'typeOfAccount', 'accountNumber', 'bank', 'transitNumber');
        } else if (fundData?.bank === 'Other') {
          fields.push(
            'depositAmount',
            'typeOfAccount',
            'accountNumber',
            'bank',
            'otherBank',
            'transitNumber'
          );
        }
      } else if (
        statementDocumentId === null &&
        statementUploadStatus === null &&
        plaidDetails.status !== ''
      ) {
        if (plaidDetails.status === 'Success') {
          fields.push('accountNumber,depositAmount');
        } else {
          fields.push('depositAmount');
        }
      }
    }

    setFocusError(fields);
    if (!isElementFound) {
      setFocus(fields);
    }
  };

  // Focus check for AnotherBankAccount mandatory fields for dgi flow
  const dgiAnotherBankValidation = () => {
    let fields = [];
    if (fundData?.debitCard) {
      fields.push('depositAmount', 'cardNumber', 'expiryMonth', 'expiryYear');
    } else if (fundData?.accountTransferOrCheck && fundData?.orientalAccount) {
      fields.push(
        'depositAmount',
        'typeOfAccount',
        'accountNumber',
        'bank',
        'transitNumber',
        'taxYear'
      );
    } else if (
      fundData?.accountTransferOrCheck &&
      fundData?.anotherBankAccount &&
      fundData?.bank !== 'Other'
    ) {
      fields.push('depositAmount', 'typeOfAccount', 'accountNumber');
      fields.push('bank', 'transitNumber', 'taxYear');
    } else if (
      fundData?.accountTransferOrCheck &&
      fundData?.anotherBankAccount &&
      fundData?.bank === 'Other'
    ) {
      fields.push(
        'depositAmount',
        'typeOfAccount',
        'accountNumber',
        'bank',
        'otherBank',
        'transitNumber',
        'taxYear'
      );
    } else {
      fields = [];
    }
    setFocusError(fields);
    if (!isElementFound) {
      setFocus(fields);
    }
  };
  // Focus check for AnotherBankAccount mandatory fields for dgi contribution product

  const dgiContAnotherBankValidation = () => {
    let fields = [];
    if (fundData?.debitCard) {
      fields.push('depositAmount', 'cardNumber', 'expiryMonth', 'expiryYear');
    } else if (fundData?.accountTransferOrCheck && fundData?.orientalAccount) {
      fields.push('depositAmount', 'typeOfAccount', 'accountNumber', 'taxYear', 'dgiAccountNumber');
    } else if (
      fundData?.accountTransferOrCheck &&
      fundData?.anotherBankAccount &&
      fundData?.bank !== 'Other'
    ) {
      fields.push(
        'depositAmount',
        'typeOfAccount',
        'accountNumber',
        'bank',
        'transitNumber',
        'taxYear',
        'dgiAccountNumber'
      );
    } else if (
      fundData?.accountTransferOrCheck &&
      fundData?.anotherBankAccount &&
      fundData?.bank === 'Other'
    ) {
      fields.push(
        'depositAmount',
        'typeOfAccount',
        'accountNumber',
        'bank',
        'otherBank',
        'transitNumber',
        'taxYear',
        'dgiAccountNumber'
      );
    } else {
      fields = [];
    }

    if (!isElementFound) {
      setFocus(fields);
    }
  };
  useEffect(() => {
    const accvalidate = async () => {
      if (accValidationErrCode === 'H') {
        setModalMessage({ ...modalMessage, message: KNOCK_OFF_MSSG_BODY, isKnockOff: true });
        await saveKnockOffData(leadGenerationContext, KNOCK_OFF_MSSG_BODY, '', expcodes);
      } else if (accValidationErrCode === 'other') {
        setModalMessage({
          ...modalMessage,
          message: FUNDING_MSSG,
          isKnockOff: false,
        });
      } else {
        setModalMessage({ message: '', isKnockOff: false });
      }
    };
    accvalidate();
  }, [accValidationErrCode, expcodes]);
  const saveFinalResult = async () => {
    const result = await saveData();
    await validatedResult(result);
  };
  const handleYesRadio = (e) => {
    if (dgiMapping(leadGenerationContext.productName)) {
      setIsFundingScreenDirty(true);
      setIsEdeliveryScreenDirty(true);
    } else {
      setIsFundingScreenDirty(true);
    }
    if (e.target.checked === true) {
      setNoRadio(false);
      setYesRadio(true);
    } else {
      setYesRadio(false);
    }
  };
  const handleNoRadio = (e) => {
    if (dgiMapping(leadGenerationContext.productName)) {
      setIsFundingScreenDirty(true);
      setIsEdeliveryScreenDirty(true);
    } else {
      setIsFundingScreenDirty(true);
    }
    if (e.target.checked === true) {
      setYesRadio(false);
      setNoRadio(true);
    } else {
      setNoRadio(false);
    }
  };
  const accValCondition = async (accountValidation) => {
    if (accountValidation.data.Status === 'Success') {
      if (accountValidation.data.ValidAccount === 'true') {
        setIsModal(false);
        setAccValidationErrCode('');
        await saveFinalResult();
      } else if (accountValidation.data.ValidAccount === 'false') {
        for (const key in accountValidation.data.ExceptionCode) {
          if (accountValidation.data.ExceptionCode[key].ExceptionCode === 'H') {
            const arrExpCode = [];
            arrExpCode.push(accountValidation.data.ExceptionCode[key]);
            setExpcodes(arrExpCode);

            setAccValidationErrCode('H');
            break;
          } else {
            setAccValidationErrCode('other');
          }
        }
        setIsModal(true);
        setIsValidating(false);
      }
    } else {
      setIsValidating(false);
      setIsModal(true);
      setModalMessage({
        ...modalMessage,
        message: FUNDING_MSSG,
        isKnockOff: false,
      });
    }
  };
  const disableAccountValidation = (accountValidation) => {
    const arr = [];
    accNoListForOrientalAccount.forEach((option) => {
      if (!option?.isValid) {
        // const accNo = accountValidation.data.AcctNbr.replace('*', '');
        const accNo = accountValidation.data.AccountId;

        const isValid = accNo === option.Id;
        arr.push({ ...option, isValid });
      } else {
        arr.push({ ...option, isValid: true });
      }
    });
    return arr;
  };
  const accValConditionProgressa = async (accountValidation, accountValidationPayload) => {
    if (accountValidation.data.Status === 'Success') {
      if (accountValidation.data.ValidAccount === 'true') {
        setIsModal(false);
        setAccValidationErrCode('');
        await saveFinalResult();
      } else if (accountValidation.data.ValidAccount === 'false') {
        let dormantInactive = false;

        if (accountValidation.data.ExceptionDetails.DormAcctInd === 'true') {
          const updateAccountDetails = disableAccountValidation(accountValidation);
          setAccNoListForOrientalAccount(updateAccountDetails);
          accountValidation.data.ExceptionCode.forEach((exception) => {
            if (
              exception.ExceptionMessage === 'DORMANT ACCOUNT' ||
              exception.ExceptionMessage === 'INACTIVE ACCOUNT'
            ) {
              dormantInactive = true;
              leadGenerationContext.setDormantAcntNo(accountValidationPayload.AcctNbr);

              setIsModal(true);
              setModalMessage({
                ...modalMessage,
                message:
                  'The account selected is dormant or inactive. Please review your selection.',
                isKnockOff: false,
              });
            }
          });
        }

        if (accountValidation.data.ExceptionCode.length > 0 && !dormantInactive) {
          const updateAccountDetails = disableAccountValidation(accountValidation);
          setAccNoListForOrientalAccount(updateAccountDetails);
          for (const key in accountValidation.data.ExceptionCode) {
            if (accountValidation.data.ExceptionCode[key].ExceptionCode === 'H') {
              const arrExpCode = [];
              arrExpCode.push(accountValidation.data.ExceptionCode[key]);
              setExpcodes(arrExpCode);

              setAccValidationErrCode('H');
              break;
            } else {
              setAccValidationErrCode('other');
            }
          }
          setIsModal(true);
          setIsValidating(false);
        }
        setIsValidating(false);
      }
    } else {
      setIsValidating(false);
      setIsModal(true);
      const updateAccountDetails = disableAccountValidation(accountValidation);
      setAccNoListForOrientalAccount(updateAccountDetails);
      setModalMessage({
        ...modalMessage,
        message: FUNDING_MSSG,
        isKnockOff: false,
      });
    }
  };

  const handleAccValidation = async (accountValidation, accountValidationPayload) => {
    if (accountValidation && accountValidation.status === 200) {
      if (isPlaidProduct(leadGenerationContext.productName) && fundData.orientalAccount) {
        accValConditionProgressa(accountValidation, accountValidationPayload);
      } else {
        accValCondition(accountValidation);
      }
    } else if (accountValidation?.status === 500) {
      setIsValidating(false);
      await saveFinalResult();
    } else {
      setIsValidating(false);
    }
  };
  const handleRoutingFunding = () => {
    if (
      leadGenerationContext.customerType === 'ETB' &&
      leadGenerationContext.flowTypeETB === 'EtbFlow'
    ) {
      if (isCDproduct(productName) || isCDIraproduct(productName)) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
            leadGenerationContext.productName
          )}/cd-review`
        );
      } else {
        handleETBFlow(leadGenerationContext, history, 'consent-info');
      }
    } else if (dgiMapping(productName) === PROD_NM_DGI_CONTRIBUTION) {
      history.push(
        `/${leadGenerationContext.location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/consent-info`
      );
    } else if (dgiMapping(productName)) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/edelivery-info`
      );
    } else if (dgiContMapping(productName)) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/consent-info`
      );
    } else if (isCDproduct(productName) || isCDIraproduct(productName)) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          leadGenerationContext.productName
        )}/cd-review`
      );
    } else {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          leadGenerationContext.productName
        )}/consent-info`
      );
    }
  };
  const continueAction = async () => {
    const accountValidationPayload = isPlaidProduct(leadGenerationContext.productName)
      ? {
          AcctNbr: fundData.orientalAccount ? orientalAccountCardValue?.Id : fundData.maskedAccId,
          AccountMasked: 'true',
          ApplicationId: applicationId || customerAppId,
        }
      : {
          AcctNbr: fundData.accountNumber,
        };

    let accountValidation = null;
    if (fundData.orientalAccount && plaidDetails?.status !== 'Success') {
      accountValidation = await getAccountValidation(
        accountValidationPayload,
        leadGenerationContext.accessToken
      );
      handleAccValidation(accountValidation, accountValidationPayload);
    } else {
      await saveFinalResult();
    }
  };

  // handle continue change
  const continueStep = async (e) => {
    e.preventDefault();
    setIsValidating(true);
    if (isFundingScreenDirty) {
      const isValid = isFormValid();
      const plaidStatementMandatory =
        isPlaidProduct(leadGenerationContext.productName) &&
        fundData.anotherBankAccount &&
        !statementDocumentId &&
        statementUploadStatus !== 'DONE' &&
        plaidDetails?.status !== 'Success' &&
        plaidDetails?.status !== 'Pending';
      if (plaidStatementMandatory) {
        setPlaidStatementMandatoryError(true);
        const element = document.getElementById('plaid-statement-error');
        element?.focus();
      }

      if (isValid && !plaidStatementMandatory) {
        continueAction();
      } else {
        if (dgiMapping(productName) === PROD_NM_DGI_CONTRIBUTION) {
          dgiContOrientalValidation();
          dgiContAnotherBankValidation();
          anotherBankAccountUploadDocFocus();
        } else if (dgiMapping(productName)) {
          dgiOrientalValidation();
          dgiAnotherBankValidation();
          anotherBankAccountUploadDocFocus();
        } else {
          orientalValidation();
          if (isPlaidProduct(leadGenerationContext.productName)) {
            anotherBankValidationPlaid();
          } else {
            anotherBankValidation();
          }
          anotherBankAccountUploadDocFocus();
        }
        setIsValidating(false);
      }
    } else {
      setIsValidating(false);
      setIsFundingScreenDirty(false);
      handleRoutingFunding();
    }
    // setIsValidating(false);
  };

  /**
   * Handle Save Application button: Should be navigated to Save Application Page */
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };

  const alignCheck = () =>
    isPlaidProduct(leadGenerationContext.productName) ? 12 : fundData.orientalAccount ? 12 : 6;

  const handleToggleOri = (e) => {
    setIsFundingScreenDirty(true);
    setPlaidStatementMandatoryError(false);
    if (
      accNoListForOrientalAccount?.length > 0 &&
      customerType === 'ETB' &&
      isPlaidProduct(leadGenerationContext.productName)
    ) {
      const updateAccountDetails = accNoListForOrientalAccount.map((option) => {
        const val = option.Balance.replace(/,/g, '');
        const balance = parseFloat(val);
        let isDepositeGreaterThanBalance = false;
        if (fundData.minDepositAmount && option.Balance != '') {
          isDepositeGreaterThanBalance = balance < fundData.minDepositAmount;
        }
        return { ...option, isDepositeGreaterThanBalance, isDepositeError: false };
      });
      setAccNoListForOrientalAccount(updateAccountDetails);
    }
    const isOriental = e.target.innerText?.replace(/\n/g, '')?.toLowerCase()?.includes('oriental');

    if (isBundle(productName)) {
      setFundData((prevState) => ({
        ...prevState,
        orientalAccount: isOriental,
        anotherBankAccount: !isOriental,
      }));
    } else {
      setFundData((prevState) => ({
        ...prevState,
        orientalAccount: e.target.checked,
        anotherBankAccount: !e.target.checked,
      }));
    }

    if (e.target.checked === true || e.target.checked === false || e.target?.innerText === '') {
      setStatementUploadStatus(null);
      setStatementDocumentId(null);
    }
    setSelectedOrientalAccountProgress({});
    setFundData((prevState) => ({
      ...prevState,
      Id: '',
      depositAmount: '',
      cardNumber: '',
      expiryMonth: 'MMM',
      expiryYear: 'YYYY',
      typeOfAccount: '',
      accountNumber: '',
      dgiAccountNumber: '',
      bank: '',
      otherBank: '',
      taxYear: '',
      transitNumber: '',
    }));
    setOrientalAccountCardValue({ Id: '' });
    setNoRadio(false);
    setYesRadio(true);
    setFundDataErrors({});
    setNoRadio(false);
    setYesRadio(true);
    setExpcodes([]);
    // fundData?.orientalAccount
  };
  const handleToggleAnother = (e) => {
    setIsFundingScreenDirty(true);
    setPlaidStatementMandatoryError(false);
    setSelectedOrientalAccountProgress({});

    const isAnotherBank =
      e.target.innerText?.replace(/\n/g, '')?.toLowerCase()?.includes('another bank') ||
      e.target.innerText?.replace(/\n/g, '')?.toLowerCase()?.includes('cuenta bancaria');

    if (isBundle(productName)) {
      setFundData((prevState) => ({
        ...prevState,
        anotherBankAccount: isAnotherBank,
        orientalAccount: !isAnotherBank,
      }));
    } else {
      setFundData((prevState) => ({
        ...prevState,
        anotherBankAccount: e.target.checked,
        orientalAccount: !e.target.checked,
      }));
    }

    // const resetDisableCondition = accNoListForOrientalAccount.map((item) => ({
    //   ...item,
    //   isDepositeGreaterThanBalance: false,
    //   isDepositeError: false,
    // }));

    if (
      accNoListForOrientalAccount?.length > 0 &&
      customerType === 'ETB' &&
      isPlaidProduct(leadGenerationContext.productName)
    ) {
      const updateAccountDetails = accNoListForOrientalAccount.map((option) => {
        const val = option.Balance.replace(/,/g, '');
        const balance = parseFloat(val);
        let isDepositeGreaterThanBalance = false;
        if (fundData.minDepositAmount && option.Balance != '') {
          isDepositeGreaterThanBalance = balance < fundData.minDepositAmount;
        }
        return { ...option, isDepositeGreaterThanBalance, isDepositeError: false };
      });
      setAccNoListForOrientalAccount(updateAccountDetails);
    }
    // setAccNoListForOrientalAccount(resetDisableCondition);
    if (e.target.checked === true || e.target.checked === false || e.target.innerText === '') {
      setStatementUploadStatus(null);
      setStatementDocumentId(null);
    }
    setFundData((prevState) => ({
      ...prevState,
      depositAmount: '',
      cardNumber: '',
      expiryMonth: 'MMM',
      expiryYear: 'YYYY',
      accountNumber: '',
      typeOfAccount: '',
      dgiAccountNumber: '',
      bank: '',
      otherBank: '',
      taxYear: '',
      transitNumber: '',
    }));
    setOrientalAccountCardValue({ Id: '' });
    setNoRadio(false);
    setYesRadio(true);
    setFundDataErrors({});
    setNoRadio(false);
    setYesRadio(true);
    setExpcodes([]);
    // fundData?.orientalAccount
  };
  // OrientalAccount and AnotherBankAccount toggle button
  const conditionOriToggle =
    (customerType === 'ETB' &&
      accNoListForOrientalAccount?.length === 0 &&
      isPlaidProduct(leadGenerationContext.productName)) ||
    (customerType === 'NTB' && isPlaidProduct(leadGenerationContext.productName));

  const orientalAnotherBankToggleButtons = () =>
    conditionOriToggle ? (
      ''
    ) : fundData?.accountTransferOrCheck ? (
      <Grid container size={{ xs: 12, md: 12, sm: 12 }} sx={classes.toggleGridStyle}>
        <Grid
          container
          size={{ xs: 12, md: 12, sm: 12, lg: 8 }}
          style={{ display: 'flex', alignItems: 'flex-start' }}
        >
          <Grid
            role="application"
            aria-roledescription={t('Oriental Account', {
              defaultValue: 'Oriental Account',
            })}
            aria-labelledby="fundingheading"
            sx={[classes.toggleStyle, classes.fundingFlex]}
            size={{ xs: 12, md: 6, sm: 12 }}
          >
            <Box component="span" sx={classes.oriLabel}>
              {t('Oriental Account', {
                defaultValue: 'Oriental Account',
              })}
            </Box>
            <CustomSwitch
              disable={
                (plaidDetails?.status === 'Pending' ||
                  plaidDetails?.status === 'Success' ||
                  (statementDocumentId !== null && statementUploadStatus !== null) ||
                  statementUploadLoading) &&
                isPlaidProduct(leadGenerationContext.productName)
              }
              // InputClassName={DisableSwitch && `${classes.disableSwitch}`}
              id="orientalAccount"
              ariaLabelName={t('Oriental Account', {
                defaultValue: 'Oriental Account',
              })}
              defaultData={fundData?.orientalAccount}
              ariaLabelledby="toggleone"
              handleClickCheckbox={handleToggleOri}
              dataTestId="orientalAccount_id"
            />
          </Grid>

          <Grid
            role="application"
            aria-roledescription={t('Another Bank Account', {
              defaultValue: 'Another Bank Account',
            })}
            size={{ xs: 12, md: 6, sm: 12 }}
            sx={classes.fundingFlex}
          >
            <Box component="span" sx={classes.oriLabel}>
              {t('Another Bank Account', {
                defaultValue: 'Another Bank Account',
              })}
            </Box>
            <CustomSwitch
              disable={
                (plaidDetails?.status === 'Pending' ||
                  plaidDetails?.status === 'Success' ||
                  (statementDocumentId !== null && statementUploadStatus !== null) ||
                  statementUploadLoading) &&
                isPlaidProduct(leadGenerationContext.productName)
              }
              id="anotherBankAccount"
              ariaLabelName={t('Another Bank Account', {
                defaultValue: 'Another Bank Account',
              })}
              defaultData={fundData?.anotherBankAccount}
              ariaLabelledby="toggletwo"
              handleClickCheckbox={handleToggleAnother}
              dataTestId="anotherBankAccount_id"
            />
          </Grid>
        </Grid>
      </Grid>
    ) : (
      ''
    );

  const orientalAnotherBankToggleButtonsBundle = () =>
    conditionOriToggle ? (
      ''
    ) : fundData?.accountTransferOrCheck ? (
      <CustomSwitchFunding
        handleToggleOri={handleToggleOri}
        handleToggleAnother={handleToggleAnother}
      />
    ) : (
      ''
    );

  let value;
  const debitCardOrAccounts = () => {
    if (fundData.debitCard) {
      value = <DebitCard />;
    } else if (fundData?.accountTransferOrCheck && fundData?.orientalAccount) {
      value = (
        <OrientalAccount
          setIsSubmitClicked={setIsSubmitClicked}
          isSubmitClicked={isSubmitClicked}
        />
      );
    } else if (fundData?.accountTransferOrCheck && fundData?.anotherBankAccount) {
      value = <AnotherBankAccount />;
    } else {
      value = null;
    }
    return value;
  };
  const renderAccountTypeProgress = () => {
    let element = null;
    if (customerType === 'ETB') {
      if (accNoListForOrientalAccount?.length > 0) {
        // etb and accounts > 0
        if (fundData?.orientalAccount && fundData?.accountTransferOrCheck) {
          element = (
            <OrientalAccount
              setIsSubmitClicked={setIsSubmitClicked}
              isSubmitClicked={isSubmitClicked}
            />
          );
        } else if (fundData?.accountTransferOrCheck && fundData?.anotherBankAccount) {
          element = <AnotherBankAccountPlaid ready={ready} open={open} />;
        }
      } else {
        element = <AnotherBankAccountPlaid ready={ready} open={open} />;
      }
    } else if (customerType === 'NTB') {
      // ntb
      element = <AnotherBankAccountPlaid ready={ready} open={open} />;
    } else {
      // ntb
      element = <AnotherBankAccountPlaid ready={ready} open={open} />;
    }
    return element;
  };

  const anotherAccountUploadStatement = () =>
    !(fundData?.accountTransferOrCheck && fundData?.orientalAccount) && (
      <Grid size={{ xs: 12, md: 6, sm: 12 }} style={{ paddingLeft: 0 }}>
        <Box component="div" sx={classes.statement_upload_style_adjust}>
          <StatementUpload
            fileType="Check Or Bank Statement"
            pagePath="funding-info"
            isBundle={isBundle(productName)}
          />
        </Box>
      </Grid>
    );

  const mainContent = () => (
    <>
      {!isValidating && (
        <Grid container spacing={0}>
          {(customerType === 'ETB' &&
            accNoListForOrientalAccount?.length === 0 &&
            isPlaidProduct(leadGenerationContext.productName)) ||
          (customerType === 'NTB' &&
            isPlaidProduct(leadGenerationContext.productName) &&
            !isBundle(productName)) ? (
            ''
          ) : customerType === 'NTB' && isBundle(productName) ? (
            <Typography component="h6" sx={classes.depositHeading}>
              {t(FUNDING_DEPOSIT_QUESTION, {
                defaultValue: FUNDING_DEPOSIT_QUESTION,
              })}
            </Typography>
          ) : (
            <Grid container>
              <Grid size={{ xs: 12 }}>
                <Typography
                  sx={{
                    ...(isBundle(productName) ? classes.fund_heading_bundle : classes.fund_heading),
                    color: theme?.palette?.primary?.main,
                  }}
                  id="fundingheading"
                  component="h2"
                  aria-label={t(FUNDING_TEXT, {
                    defaultValue: FUNDING_TEXT,
                  })}
                >
                  {t(FUNDING_TEXT, {
                    defaultValue: FUNDING_TEXT,
                  })}
                </Typography>
              </Grid>
            </Grid>
          )}

          {isBundle(productName)
            ? orientalAnotherBankToggleButtonsBundle()
            : orientalAnotherBankToggleButtons()}

          {/* Bundle layout Toggle button */}
          {/* {orientalAnotherBankToggleButtonsBundle()} */}
          {/* {orientalAnotherBankToggleButtons()} */}

          <Grid container size={{ xs: 12, md: 12 }}>
            <div
              role="alert"
              data-testid="plaid-statement-error"
              id="plaid-statement-error"
              tabIndex={plaidStatementMandatoryError ? '0' : '-1'}
            >
              {plaidStatementMandatoryError && (
                <Box component="span" sx={classes.error_message} style={{ marginBottom: '15px' }}>
                  {t(
                    'Please complete the account verification using Plaid or upload a check/bank statement.',
                    {
                      defaultValue:
                        'Please complete the account verification using Plaid or upload a check/bank statement.',
                    }
                  )}
                </Box>
              )}
            </div>
            <Grid
              size={{ md: alignCheck() }}
              container
              role="region"
              style={{ height: 'fit-content' }}
            >
              {isPlaidProduct(leadGenerationContext.productName)
                ? renderAccountTypeProgress()
                : debitCardOrAccounts()}
            </Grid>
            {isPlaidProduct(leadGenerationContext.productName)
              ? ''
              : anotherAccountUploadStatement()}
          </Grid>
          {productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN &&
            !fundData?.anotherBankAccount && (
              <Box
                component="div"
                sx={fundData?.anotherBankAccount ? classes.outerDivAnother : classes.outerDiv}
              >
                <div>
                  <Box
                    component="img"
                    id="initialDepositIcon"
                    tabIndex="0"
                    sx={classes.imgDivDesign}
                    src={NewAddressImage}
                    alt={t('Where my initial deposit will go?', {
                      defaultValue: 'Where my initial deposit will go?',
                    })}
                    aria-describedby="initialDepositDesc initialDepositDesc2 initialDepositDesc3 fundScreenDesc"
                  />
                </div>
                <div>
                  <Typography sx={classes.mainHeading}>
                    {t('Where my initial deposit will go?', {
                      defaultValue: 'Where my initial deposit will go?',
                      nsSeparator: '|',
                    })}
                  </Typography>
                  <Box component="span" sx={classes.subHeading} id="initialDepositDesc">
                    {t('Your initial deposit will be reflected in your ', {
                      defaultValue: 'Your initial deposit will be reflected in your ',
                    })}
                  </Box>
                  <Box component="span" sx={classes.chkAccountHeading} id="initialDepositDesc2">
                    {t('CHECKING SECTION.', {
                      defaultValue: 'CHECKING SECTION.',
                    })}
                  </Box>
                  <Box component="span" sx={classes.subHeading} id="initialDepositDesc3">
                    {t(
                      ' Remember you can transfer your money to your saving section at any time on our Online Banking app.',
                      {
                        defaultValue:
                          ' Remember you can transfer your money to your saving section at any time on our Online Banking app.',
                      }
                    )}
                  </Box>
                </div>
              </Box>
            )}
          <Grid container size={{ xs: 12 }} sx={classes.gridSpace}>
            {isPlaidProduct(leadGenerationContext.productName)
              ? ''
              : fundData?.accountTransferOrCheck &&
                fundData?.anotherBankAccount && (
                  <Box component="div" sx={classes.gridBorder}>
                    <Box component="span" sx={classes.radio_text}>
                      {t('Does this account belong to you?', {
                        defaultValue: 'Does this account belong to you?',
                      })}
                    </Box>
                    <Box component="div" sx={classes.radioStyle}>
                      <Box component="div" sx={[classes.toggleStyle, classes.fundingFlex]}>
                        <CustomRadio
                          size="small"
                          classes={{ root: classes.radioRoot }}
                          checked={yesRadio}
                          onChange={handleYesRadio}
                          value="Yes"
                          inputProps={{
                            'data-testid': 'yes_testid',
                          }}
                          id="yes"
                          name="yes"
                          aria-label="yes"
                        />
                        <InputLabel for="yes" sx={classes.radioLabelStyle}>
                          {t('Yes', {
                            defaultValue: 'Yes',
                          })}
                        </InputLabel>
                      </Box>
                      <Box component="div" sx={[classes.toggleStyle, classes.fundingFlex]}>
                        <CustomRadio
                          size="small"
                          classes={{ root: classes.radioRoot }}
                          checked={noRadio}
                          onChange={handleNoRadio}
                          value="No"
                          inputProps={{
                            'data-testid': 'NO_checkbox_testid',
                          }}
                          id="NO"
                          name="NO"
                          aria-label="NO"
                        />
                        <InputLabel for="NO" sx={classes.radioLabelStyle}>
                          {t('No', {
                            defaultValue: 'No',
                          })}
                        </InputLabel>
                      </Box>
                    </Box>
                  </Box>
                )}
            {productMapping(productName) === ELITE_ACCOUNT_EN && fundData?.anotherBankAccount && (
              <Box
                component="div"
                sx={fundData?.anotherBankAccount ? classes.outerDivAnother : classes.outerDiv}
              >
                <div>
                  <Box
                    component="img"
                    id="initialDepositIcon"
                    tabIndex="0"
                    sx={classes.imgDivDesign}
                    src={NewAddressImage}
                    alt={t('Where will my initial deposit go?', {
                      defaultValue: 'Where will my initial deposit go?',
                    })}
                    aria-describedby="initialDepositDesc initialDepositDesc2 initialDepositDesc3 fundScreenDesc"
                  />
                </div>
                <div>
                  <Typography sx={classes.mainHeading}>
                    {t('Where will my initial deposit go?', {
                      defaultValue: 'Where will my initial deposit go?',
                    })}
                  </Typography>
                  <Box component="span" sx={classes.subHeading} id="initialDepositDesc">
                    {t('Your initial deposit will be reflected in your ', {
                      defaultValue: 'Your initial deposit will be reflected in your ',
                    })}
                  </Box>
                  <Box component="span" sx={classes.chkAccountHeading} id="initialDepositDesc2">
                    {t('CHECKING SECTION.', {
                      defaultValue: 'CHECKING SECTION.',
                    })}
                  </Box>
                  <Box component="span" sx={classes.subHeading} id="initialDepositDesc3">
                    {t(
                      ' Remember you can transfer your money to your saving section at any time on our Online Banking app.',
                      {
                        defaultValue:
                          ' Remember you can transfer your money to your saving section at any time on our Online Banking app.',
                      }
                    )}
                  </Box>
                </div>
              </Box>
            )}
            <Typography
              id="fundScreenDesc"
              variant={commonTernary(isBundle(productName), 'subtitle1', '')}
              sx={
                isBundle(productName)
                  ? {
                      color: theme?.palette?.primary?.main,
                    }
                  : classes.contact_terms
              }
            >
              {t(
                isBundle(productName)
                  ? 'BundleFundingScreenDisclaimer'
                  : isPlaidProduct(leadGenerationContext.productName)
                  ? 'FundingScreenDisclaimerProg'
                  : 'FundingScreenDisclaimer',
                {
                  defaultValue: isBundle(productName)
                    ? BUNDLE_FUNDING_DISCLAIMER
                    : FUNDING_DISCLAIMER,
                }
              )}
            </Typography>
          </Grid>
        </Grid>
      )}
      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage="funding-info" />
      )}

      <KnockOffModal
        message={modalMessage}
        setIsModal={setIsModal}
        openModal={isModal && !(isBundle(productName) && modalMessage.isKnockOff)}
      />
      <BundleErrorModal
        message={{
          errorHead: VOUCHED_ERROR,
          errorTitle: NOT_ELIGIBLE,
          errorDescription: NOT_ELIGIBLE_DESCRIPTION,
        }}
        setIsModal={setIsModal}
        openModal={isModal && isBundle(productName) && modalMessage.isKnockOff}
      />

      {leadGenerationContext.openModalGlobal && (
        <CommonModal
          message={leadGenerationContext.modalMessageGlobal}
          setIsModal={leadGenerationContext.setOpenModalGlobal}
          openModal={leadGenerationContext.openModalGlobal}
        />
      )}
    </>
  );
  const oldLayout = () => (
    <Layout
      ariaDescribedby="FundingScreenHeading"
      headingId="FundingScreenHeading"
      ff
      ariaDescribedbyId="FundingScreenDesc"
      classes={classes}
      descriptionKey={
        isPlaidProduct(leadGenerationContext.productName)
          ? 'Funding Screen Description Prog'
          : 'Funding Screen Description'
      }
      descriptionValue={FUNDING_HEAD}
      stepValue={2}
      handleBack={back}
      handleContinue={continueStep}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        isPlaidProduct(leadGenerationContext.productName)
          ? ProgresaImage2
          : dgiContMapping(productName)
          ? RetailImage2
          : RetailImage3
      }
    >
      <Box component="div" sx={classes.fund_grid_margin} data-page="funding-info">
        {mainContent()}
      </Box>
    </Layout>
  );

  const bundleLayout = () => (
    <NewLayout
      ariaDescribedby="FundingScreenHeading"
      headingId="FundingScreenHeading"
      ff
      ariaDescribedbyId="FundingScreenDesc"
      classes={classes}
      descriptionKey={
        isPlaidProduct(leadGenerationContext.productName)
          ? 'Funding Screen Description Prog'
          : 'Funding Screen Description'
      }
      descriptionValue={FUNDING_HEAD}
      stepValue={5}
      handleBack={back}
      handleContinue={continueStep}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        isPlaidProduct(leadGenerationContext.productName)
          ? ProgresaImage2
          : dgiContMapping(productName)
          ? RetailImage2
          : RetailImage3
      }
    >
      <Grid data-page="funding-info">{mainContent()}</Grid>
    </NewLayout>
  );

  return isBundle(productName) ? bundleLayout() : oldLayout();
};

export default withRouter(FundingScreen);

FundingScreen.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
